import React from 'react';

import {TypeImplementation, getSystem, Types} from '@packages/systems/wfdl';
import {EBoolean, TBoolean} from '@packages/systems/wfdl-ast';
import {
  ContextualExpressions,
  getAnn,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {Checkbox} from '@packages/systems/spring';

/**
 * A Boolean that renders its own label to the right of the checkbox, matching
 * the Advanced section's checkboxes. Give the field `labelVariant: 'hidden'`
 * so the settings grid doesn't also render the label in its left column.
 */
export const LabeledCheckboxType = TypeImplementation.Alias({
  type: TBoolean,
  render: ({expr, dispatch}) => {
    const type = getAnn(expr)?.type;
    const label = (type && getSystem(type)?.label) || '';
    const isChecked = ContextualExpressions.getBoolean(stripAnn(expr)) || false;

    return (
      <Checkbox
        label={label}
        isChecked={isChecked}
        data-automation-id={
          type ? Types.generateAutomationIds(type) : 'boolean-primitive'
        }
        onChange={() => {
          dispatch(updateExpressionAction(EBoolean(!isChecked)));
        }}
      />
    );
  },
  system: {defaultValue: false},
});
